<template>
  <Layout>
    <div class="shopping-cart">
      <h1 class="main-title">購物車</h1>
      <h2 class="sub-title">SHOPPING CART</h2>
      
      <!-- 進度條 -->
      <div class="progress-bar">
        <div class="progress-step active">
          <div class="step-number">1</div>
          <div class="step-label">購物車</div>
        </div>
        <div class="progress-line"></div>
        <div class="progress-step">
          <div class="step-number">2</div>
          <div class="step-label">結帳</div>
        </div>
        <div class="progress-line"></div>
        <div class="progress-step">
          <div class="step-number">3</div>
          <div class="step-label">完成</div>
        </div>
      </div>

      <!-- 購物車內容 -->
      <div class="cart-content">
        <!-- 購物車商品列表 -->
        <div class="cart-items">
          <div v-for="item in cartItems" :key="item.id" class="cart-item">
            <img :src="item.image" :alt="item.name" class="item-image">
            <div class="item-details">
              <h3 class="item-name">{{ item.name }}</h3>
              <div class="item-variants">
                <span class="variant">{{ item.color }}</span>
                <span class="variant">{{ item.size }}</span>
              </div>
              <div class="item-price">$NTD {{ item.price }}</div>
            </div>
            <div class="item-quantity">
              <button @click="updateQuantity(item, -1)" class="quantity-btn">-</button>
              <span class="quantity">{{ item.quantity }}</span>
              <button @click="updateQuantity(item, 1)" class="quantity-btn">+</button>
            </div>
            <button @click="removeFromCart(item)" class="remove-btn">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>

        <!-- 右側：優惠券和結帳明細 -->
        <div class="checkout-summary">
          <!-- 優惠券 -->
          <div class="coupon-section">
            <h3>優惠券</h3>
            <div class="coupon-input">
              <input 
                type="text" 
                v-model="discountCode" 
                placeholder="請輸入優惠碼"
                @keyup.enter="applyDiscount"
              >
              <button @click="applyDiscount" class="apply-btn">套用</button>
            </div>
          </div>

          <!-- 結帳明細 -->
          <div class="order-summary">
            <h3>結帳明細</h3>
            <div class="summary-details">
              <div class="summary-row">
                <span>小計</span>
                <span>$NTD {{ subtotal }}</span>
              </div>
              <div v-if="discount" class="summary-row discount">
                <span>折扣</span>
                <span>-$NTD {{ discount }}</span>
              </div>
              <div class="summary-row">
                <span>運費</span>
                <span>$NTD {{ shipping }}</span>
              </div>
              <div class="summary-row">
                <span>稅金</span>
                <span>$NTD {{ tax }}</span>
              </div>
              <div class="summary-row total">
                <span>總計</span>
                <span>$NTD {{ total }}</span>
              </div>
            </div>
          </div>

          <!-- 前往結帳按鈕 -->
          <button @click="proceedToCheckout" class="checkout-btn">
            前往結帳
          </button>
          <p class="terms-notice">
            按下「前往結帳」按鈕即代表您同意本公司的
            <router-link to="/privacy-policy">服務條款及隱私權政策</router-link>
          </p>

          <!-- 支援付款方式 -->
          <div class="payment-methods">
            <h3>支援付款方式</h3>
            <div class="payment-icons">
              <img v-for="(icon, index) in paymentIcons" 
                    :key="index" 
                    :src="icon" 
                    :alt="'payment-' + index">
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Layout from '@/layouts/Layout.vue'

export default {
  name: 'Cart',
  components: {
    Layout
  },
  data() {
    return {
      discountCode: '',
      discount: 0,
      paymentIcons: [
        require('@/assets/img/visa.svg'),
        require('@/assets/img/master-card.svg'),
        require('@/assets/img/apple-pay.svg'),
        require('@/assets/img/jkopay.svg'),
        require('@/assets/img/line-pay.svg'),
        require('@/assets/img/unionpay.svg')
      ],
    }
  },
  computed: {
    ...mapState(['cartItems']),
    subtotal() {
      return this.cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0)
    },
    shipping() {
      return 10
    },
    tax() {
      return (this.subtotal - this.discount) * 0.1
    },
    total() {
      return this.subtotal - this.discount + this.shipping + this.tax
    }
  },
  methods: {
    ...mapMutations(['updateCartItemQuantity', 'removeFromCart']),
    updateQuantity(item, change) {
      const newQuantity = item.quantity + change
      if (newQuantity > 0) {
        this.updateCartItemQuantity({ item, quantity: newQuantity })
      }
    },
    proceedToCheckout() {
      this.$router.push('/checkout/order')
    },
    applyDiscount() {
      if (this.discountCode === 'SAVE20') {
        this.discount = this.subtotal * 0.2
      } else if (this.discountCode === 'SAVE10') {
        this.discount = this.subtotal * 0.1
      } else {
        this.discount = 0
        alert('無效的優惠碼')
      }
    }
  }
}
</script>

<style scoped>
.shopping-cart {
  max-width: 1200px;
  margin: 80px auto 2rem auto;
  padding: 0 2rem;
}

.main-title {
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0.5rem;
}

.sub-title {
  font-size: 1rem;
  color: #666;
  text-align: center;
  margin-bottom: 2rem;
}

.progress-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
}

.progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #F99393;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.progress-step.active .step-number {
  background-color: #F99393;
  color: white;
}

.progress-line {
  position: relative;
  top: -15px;
  width: 100px;
  height: 2px;
  background-color: #F99393;
  margin: 0 1rem;
}

.cart-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
}

.cart-items {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cart-item {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  gap: 1rem;
  padding: 2rem;
  background-color: #FBFBFB;
  border-radius: 8px;
}

.item-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
}

.item-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.item-name {
  font-size: 1.1rem;
  font-weight: 500;
}

.item-variants {
  display: flex;
  gap: 1rem;
}

.variant {
  color: #666;
  font-size: 0.9rem;
}

.item-price {
  font-weight: 500;
}

.item-quantity {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.quantity-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #ddd;
  background: none;
  cursor: pointer;
}

.quantity {
  min-width: 30px;
  text-align: center;
}

.remove-btn {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
}

.checkout-summary {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.coupon-section,
.order-summary,
.payment-methods {
  background-color: #f9f9f9;
  padding: 1.5rem;
  border-radius: 8px;
}

.coupon-input {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
}

.coupon-input input {
  flex: 1;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.apply-btn {
  padding: 0.5rem 1rem;
  background-color: #F99393;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.summary-details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  color: #666;
}

.summary-row.discount {
  color: #4CAF50;
}

.summary-row.total {
  font-weight: bold;
  color: #000;
  font-size: 1.2rem;
  border-top: 1px solid #ddd;
  padding-top: 1rem;
  margin-top: 1rem;
}

.checkout-btn {
  width: 100%;
  padding: 1rem;
  background-color: #F99393;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.checkout-btn:hover {
  color: white;
}

.payment-icons {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  font-size: 2rem;
  color: #666;
}

.terms-notice {
  margin-top: 1rem;
  font-size: 1.2rem;
  color: #666;
  text-align: center;
}

.terms-notice a {
  color: #F99393;
  text-decoration: none;
}

.terms-notice a:hover {
  text-decoration: underline;
}
</style> 